import styled from 'styled-components';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Table as GlobalTable } from 'styles/global';

export const Table = styled(GlobalTable)`
  th {
    &:nth-of-type(2) {
      width: 9rem;
      text-align: center;
    }
    &:nth-of-type(3) {
      width: 9rem;
      text-align: center;
    }
    &:nth-of-type(4) {
      width: 6rem;
      text-align: center;
    }
    &:nth-of-type(5) {
      width: 5rem;
      text-align: center;
    }
    &:nth-of-type(6) {
      width: 6rem;
      text-align: center;
    }
    &:nth-of-type(7) {
      width: 1rem;
      text-align: center;
    }
  }
  td {
    &:nth-of-type(5) {
      > div {
        display: flex !important;
        margin: 0 auto;
      }
    }
  }
  td {
    &:nth-of-type(7) {
      div {
        display: flex;
        align-items: center;
      }
    }
  }
`;

export const Container = styled.div`
  /* background: ${props => props.theme.cardBackgroud}; */
  width: -webkit-fill-available;
  width: -moz-available;
  display: flex;
  flex-direction: column;


  >header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
    div{
      display: flex;
      align-items: center;
      min-width: 250px;
      width: 100%;
    }
    h4{
      min-width: 130px;
    }
  }
`;
export const Scroll = styled(PerfectScrollbar)`
  height: calc(100vh - 160px);
  padding: 0 15px;
`;

export const Td = styled.td`
  display: flex;
  align-items: center;
  padding: 10px 10px 10px 0px !important;
  font-size: 1.0625rem;

  strong {
    margin-left: 5px;
    font-size: 0.88rem;
    font-weight: normal;
    font-style: italic;

    &:before {
      content: '-';
      margin-right: 10px;
    }
  }
`;
